module.exports = __webpack_public_path__ + "img/hide_link.aa126c22.png";